<template>
  <FocusLoop>
    <div class="modal_page center">
      <form class="modal_window d-flex d-col space-between" @submit.prevent="confirmDelete">
        <div class="d-flex space-between align-center">
          <div class="font-18">
            {{ $t("modal.deleteRecording.title") }}
          </div>
          <s-icon color="grey" @click="closeModal">
            close
          </s-icon>
        </div>
        <div class="py-30">
          <div class="font-16 mb-20">
            {{ $t("modal.deleteRecording.message") }}
          </div>
          <div v-if="recordingToDelete" class="font-14 opacity-75">
            <strong>{{ recordingToDelete.title || 'Untitled Meeting' }}</strong>
            <br>
            <span class="opacity-60">{{ recordingToDelete.fileName }}</span>
          </div>
        </div>

        <div class="d-flex justify-end mt-40">
          <s-btn type="button" class="mr-10 black--text" @click="closeModal">
            {{ $t("modal.cancel") }}
          </s-btn>
          <s-btn type="submit" class="red white--text">
            {{ $t("modal.delete") }}
          </s-btn>
        </div>
      </form>
    </div>
  </FocusLoop>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { gsap } from 'gsap';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toast-notification';
import { push } from '@/assets/js/util';

const { t } = useI18n();
const store = useStore();
const $toast = useToast();

const recordingToDelete = computed(() => store.state.recordings.recordingToDelete);

const confirmDelete = async () => {
  if (recordingToDelete.value) {
    const response = await store.dispatch('recordings/deleteRecording', recordingToDelete.value.id);
    if (response.status === 'ok') {
      $toast.success(t('recordings.delete_success'), {
        position: 'top-right',
        duration: 5000,
        dismissible: true
      });
      if (window.location.pathname.includes('/recordings/') && window.location.pathname !== '/recordings') {
        push('/recordings');
      }
    } else {
      $toast.error(response.message || t('recordings.delete_error'), {
        position: 'top-right',
        duration: 5000,
        dismissible: true
      });
    }
  }
  closeModal();
};

const closeModal = () => {
  gsap.to(".modal_page", {
    opacity: 0,
    duration: 0.3,
    ease: "power2.out",
  });
  gsap.to(".modal_window", {
    scale: 0.7,
    duration: 0.3,
    ease: "power2.out",
    onComplete: () => store.commit("modals/deleteRecordingConfirmationModal", false),
  });
};

onMounted(() => {
  gsap.from(".modal_page", {
    opacity: 0,
    duration: 0.3,
    ease: "power2.out",
  });

  gsap.from(".modal_window", {
    scale: 0.7,
    duration: 0.3,
    ease: "power2.out",
  });
});
</script>

<style scoped>
.modal_page {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background: rgba(41, 41, 41, 0.6);
  z-index: 8;
}

.modal_window {
  width: 450px;
  padding: 30px;
  padding-left: 60px;
  padding-right: 60px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.35);
  background-color: var(--shade1);
  border-radius: 10px;
}

@media only screen and (max-width: 576px) {
  .modal_window {
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
  }
}
</style>
